<template>
  <div class="chart_section--item columns is-multiline m-0">
    <div class="chart_stat_box column is-3"
      v-for="(item, index) in chartData"
      :key="index"
    >
      <div class="chart_stat_box--sections">
        <div class="chart_stat_box--section">
          <h4 class="chart_stat_box--section--heading">{{ item.label }}</h4>

          <div class="chart_stat_box--section--stat">
            <p class="chart_stat_box--section--stat--count">{{ item.total }}</p>
          </div>
        </div>

        <div class="chart_stat_box--section" v-if="item.total">
          <chart-pie
            data-is-loaded
            :chart-data="item.chart"
            @click="handleClick"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartPie from "../../../components/charts/ChartPie.vue";

export default {
  name: "StatsTeamChart",
  components: {ChartPie},
  props: {
    chartData: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleClick(value) {
      /**
       * TODO open modal and API call
       * value
       * {
       *   "type": "Assigned Tasks",
       *   "id": 1, // user_id
       *   "label": "John Doe"
       * }
       */
      console.log('handleClick', value)
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../../styles/variables/variables";

.chart_section--item {
  align-items: stretch;
}

.chart_stat_box {
  position: relative;
  margin-right: 1rem;
  margin-bottom: 1rem;
  padding: 12px;
  border: 1px solid $border;

  &:nth-child(3n), &:last-child {
    margin-right: 0;
  }

  @media (min-width: 1024px) {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  @media (min-width: 1215px) {
    width: 31.5%;
  }

  &--sections {
    width: 100%;
  }

  &--section {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    &--heading {
      font-size: 15px;
      font-weight: bold;
      text-align: center;
    }

    &--stat--count {
      font-size: 25px;
      font-weight: bold;
      text-align: center;
    }
  }
}
</style>
